// Schema de la tabla `users` (global, sin tenant_id — un email puede
// pertenecer a varios tenants vía la tabla N:M `tenant_users`).
import { z } from 'zod';
export const userSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email().toLowerCase().trim(),
    nombre: z.string().trim().min(1).max(80),
    apellido: z.string().trim().min(1).max(80),
    activo: z.boolean(),
    created_at: z.string().datetime({ offset: true }),
});
/** Payload de creación de usuario (subset, sin campos generados por BD). */
export const userCreateSchema = userSchema.pick({
    email: true,
    nombre: true,
    apellido: true,
});
/** Payload de actualización de perfil (todo opcional, email NO editable acá). */
export const userUpdateSchema = z
    .object({
    nombre: z.string().trim().min(1).max(80),
    apellido: z.string().trim().min(1).max(80),
})
    .partial();
//# sourceMappingURL=user.js.map